import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'compareDatasets',
  version: '1.0.0',
  properties: [
    {
      key: 'dataset1',
      label: 'Dataset 1',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Source 1"].output.data }}',
      description: 'The first dataset (baseline) to compare',
    },
    {
      key: 'dataset2',
      label: 'Dataset 2',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Source 2"].output.data }}',
      description: 'The second dataset to compare against the first',
    },
    {
      key: 'keyField',
      label: 'Key Field',
      type: 'string',
      required: false,
      placeholder: 'e.g., id',
      description: 'Field to use as unique identifier for matching records. Leave empty to compare entire objects.',
    },
    {
      key: 'compareMode',
      label: 'Compare Mode',
      type: 'options',
      required: false,
      default: 'full',
      options: [
        { value: 'full', name: 'Full Comparison' },
        { value: 'added', name: 'Added Only' },
        { value: 'removed', name: 'Removed Only' },
        { value: 'changed', name: 'Changed Only' },
        { value: 'unchanged', name: 'Unchanged Only' },
      ],
      description: 'What type of differences to return',
    },
  ],
};

export default schema;
